import { createRouter, createWebHistory } from "vue-router";

/**
 * Fuenf Screens, flach. Die Trennung folgt einer Linie: lesen gegen arbeiten.
 * Die Uebersicht wird morgens ueberflogen; alles, was man abarbeitet oder
 * scrollt, bekommt eigenen Platz und eigenen Zustand.
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "overview", component: () => import("@/views/OverviewView.vue") },
    { path: "/abgleich", name: "reconcile", component: () => import("@/views/ReconcileView.vue") },
    { path: "/planung", name: "planning", component: () => import("@/views/PlanningView.vue") },
    { path: "/forderungen", name: "receivables", component: () => import("@/views/ReceivablesView.vue") },
    { path: "/einstellungen", name: "settings", component: () => import("@/views/SettingsView.vue") },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});
